import { Select } from 'antd';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
&.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		border-radius: 4px !important;
	}
`

export const SelectWrapper = styled(Select)`
	&.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		border-radius: 4px !important;
	}
`;
